export default {
  title: "Seite nicht gefunden",
  description: `Die Seite, die Sie suchen, wurde möglicherweise entfernt, hat ihren
              <br /> Namen geändert oder ist vorübergehend nicht verfügbar.`,
};
